import { render, staticRenderFns } from "./MyWhatsappNumber.vue?vue&type=template&id=2f82dc58&scoped=true"
import script from "./MyWhatsappNumber.vue?vue&type=script&lang=js"
export * from "./MyWhatsappNumber.vue?vue&type=script&lang=js"
import style0 from "./MyWhatsappNumber.vue?vue&type=style&index=0&id=2f82dc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82dc58",
  null
  
)

export default component.exports